import Chart from 'chart.js/auto'
/*! rangeslider.js - v2.0.0 | (c) 2015 @andreruffert | MIT license | https://github.com/andreruffert/rangeslider.js */
!function(a) {
  "use strict";
  "function" == typeof define && define.amd ? define(["jquery"], a) : a("object" == typeof exports ? require("jquery") : jQuery)
}((function(a) {
  "use strict";
  function e(a) {
      return a && (0 === a.offsetWidth || 0 === a.offsetHeight || !1 === a.open)
  }
  function f(a) {
      for (var b = [], c = a.parentNode; e(c); )
          b.push(c),
          c = c.parentNode;
      return b
  }
  function g(a, b) {
      function c(a) {
          void 0 !== a.open && (a.open = !a.open)
      }
      var d = f(a)
        , e = d.length
        , g = []
        , h = a[b];
      if (e) {
          for (var i = 0; e > i; i++)
              g[i] = d[i].style.cssText,
              d[i].style.display = "block",
              d[i].style.height = "0",
              d[i].style.overflow = "hidden",
              d[i].style.visibility = "hidden",
              c(d[i]);
          h = a[b];
          for (var j = 0; e > j; j++)
              d[j].style.cssText = g[j],
              c(d[j])
      }
      return h
  }
  function h(a, b) {
      var c = parseFloat(a);
      return Number.isNaN(c) ? b : c
  }
  function i(a) {
      return a.charAt(0).toUpperCase() + a.substr(1)
  }
  function k(b, e) {
      if (this.$window = a(window),
      this.$document = a(document),
      this.$element = a(b),
      this.options = a.extend({}, o, e),
      this.polyfill = this.options.polyfill,
      this.orientation = this.$element[0].getAttribute("data-orientation") || this.options.orientation,
      this.onInit = this.options.onInit,
      this.onSlide = this.options.onSlide,
      this.onSlideEnd = this.options.onSlideEnd,
      this.DIMENSION = p.orientation[this.orientation].dimension,
      this.DIRECTION = p.orientation[this.orientation].direction,
      this.DIRECTION_STYLE = p.orientation[this.orientation].directionStyle,
      this.COORDINATE = p.orientation[this.orientation].coordinate,
      this.polyfill && n)
          return !1;
      this.identifier = "js-" + l + "-" + m++,
      this.startEvent = this.options.startEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.moveEvent = this.options.moveEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.endEvent = this.options.endEvent.join("." + this.identifier + " ") + "." + this.identifier,
      this.toFixed = (this.step + "").replace(".", "").length - 1,
      this.$fill = a('<div class="' + this.options.fillClass + '" />'),
      this.$handle = a('<div class="' + this.options.handleClass + '" />'),
      this.$range = a('<div class="' + this.options.rangeClass + " " + this.options[this.orientation + "Class"] + '" id="' + this.identifier + '" />').insertAfter(this.$element).prepend(this.$fill, this.$handle),
      this.$element.css({
          position: "absolute",
          width: "1px",
          height: "1px",
          overflow: "hidden",
          opacity: "0"
      }),
      this.handleDown = a.proxy(this.handleDown, this),
      this.handleMove = a.proxy(this.handleMove, this),
      this.handleEnd = a.proxy(this.handleEnd, this),
      this.init();
      var f = this;
      this.$window.on("resize." + this.identifier, function d(a, b) {
          return b = b || 100,
          function() {
              if (!a.debouncing) {
                  var c = Array.prototype.slice.apply(arguments);
                  a.lastReturnVal = a.apply(window, c),
                  a.debouncing = !0
              }
              return clearTimeout(a.debounceTimeout),
              a.debounceTimeout = setTimeout((function() {
                  a.debouncing = !1
              }
              ), b),
              a.lastReturnVal
          }
      }((function() {
          !function c(a, b) {
              var c = Array.prototype.slice.call(arguments, 2);
              return setTimeout((function() {
                  return a.apply(null, c)
              }
              ), b)
          }((function() {
              f.update()
          }
          ), 300)
      }
      ), 20)),
      this.$document.on(this.startEvent, "#" + this.identifier + ":not(." + this.options.disabledClass + ")", this.handleDown),
      this.$element.on("change." + this.identifier, (function(a, b) {
          if (!b || b.origin !== f.identifier) {
              var c = a.target.value
                , d = f.getPositionFromValue(c);
              f.setPosition(d)
          }
      }
      ))
  }
  Number.isNaN = Number.isNaN || function(a) {
      return "number" == typeof a && a != a
  }
  ;
  var l = "rangeslider"
    , m = 0
    , n = function b() {
      var a = document.createElement("input");
      return a.setAttribute("type", "range"),
      "text" !== a.type
  }()
    , o = {
      polyfill: !0,
      orientation: "horizontal",
      rangeClass: "rangeslider",
      disabledClass: "rangeslider--disabled",
      horizontalClass: "rangeslider--horizontal",
      verticalClass: "rangeslider--vertical",
      fillClass: "rangeslider__fill",
      handleClass: "rangeslider__handle",
      startEvent: ["mousedown", "touchstart", "pointerdown"],
      moveEvent: ["mousemove", "touchmove", "pointermove"],
      endEvent: ["mouseup", "touchend", "pointerup"]
  }
    , p = {
      orientation: {
          horizontal: {
              dimension: "width",
              direction: "left",
              directionStyle: "left",
              coordinate: "x"
          },
          vertical: {
              dimension: "height",
              direction: "top",
              directionStyle: "bottom",
              coordinate: "y"
          }
      }
  };
  k.prototype.init = function() {
      this.update(!0, !1),
      this.$element[0].value = this.value,
      this.onInit && "function" == typeof this.onInit && this.onInit()
  }
  ,
  k.prototype.update = function(a, b) {
      (a = a || !1) && (this.min = h(this.$element[0].getAttribute("min"), 0),
      this.max = h(this.$element[0].getAttribute("max"), 100),
      this.value = h(this.$element[0].value, this.min + (this.max - this.min) / 2),
      this.step = h(this.$element[0].getAttribute("step"), 1)),
      this.handleDimension = g(this.$handle[0], "offset" + i(this.DIMENSION)),
      this.rangeDimension = g(this.$range[0], "offset" + i(this.DIMENSION)),
      this.maxHandlePos = this.rangeDimension - this.handleDimension,
      this.grabPos = this.handleDimension / 2,
      this.position = this.getPositionFromValue(this.value),
      this.$element[0].disabled ? this.$range.addClass(this.options.disabledClass) : this.$range.removeClass(this.options.disabledClass),
      this.setPosition(this.position, b)
  }
  ,
  k.prototype.handleDown = function(a) {
      if (a.preventDefault(),
      this.$document.on(this.moveEvent, this.handleMove),
      this.$document.on(this.endEvent, this.handleEnd),
      !((" " + a.target.className + " ").replace(/[\n\t]/g, " ").indexOf(this.options.handleClass) > -1)) {
          var b = this.getRelativePosition(a)
            , c = this.$range[0].getBoundingClientRect()[this.DIRECTION]
            , d = this.getPositionFromNode(this.$handle[0]) - c
            , e = "vertical" === this.orientation ? this.maxHandlePos - (b - this.grabPos) : b - this.grabPos;
          this.setPosition(e),
          b >= d && b < d + this.handleDimension && (this.grabPos = b - d)
      }
  }
  ,
  k.prototype.handleMove = function(a) {
      a.preventDefault();
      var b = this.getRelativePosition(a)
        , c = "vertical" === this.orientation ? this.maxHandlePos - (b - this.grabPos) : b - this.grabPos;
      this.setPosition(c)
  }
  ,
  k.prototype.handleEnd = function(a) {
      a.preventDefault(),
      this.$document.off(this.moveEvent, this.handleMove),
      this.$document.off(this.endEvent, this.handleEnd),
      this.$element.trigger("change", {
          origin: this.identifier
      }),
      this.onSlideEnd && "function" == typeof this.onSlideEnd && this.onSlideEnd(this.position, this.value)
  }
  ,
  k.prototype.cap = function(a, b, c) {
      return b > a ? b : a > c ? c : a
  }
  ,
  k.prototype.setPosition = function(a, b) {
      var c, d;
      void 0 === b && (b = !0),
      c = this.getValueFromPosition(this.cap(a, 0, this.maxHandlePos)),
      d = this.getPositionFromValue(c),
      this.$fill[0].style[this.DIMENSION] = d + this.grabPos + "px",
      this.$handle[0].style[this.DIRECTION_STYLE] = d + "px",
      this.setValue(c),
      this.position = d,
      this.value = c,
      b && this.onSlide && "function" == typeof this.onSlide && this.onSlide(d, c)
  }
  ,
  k.prototype.getPositionFromNode = function(a) {
      for (var b = 0; null !== a; )
          b += a.offsetLeft,
          a = a.offsetParent;
      return b
  }
  ,
  k.prototype.getRelativePosition = function(a) {
      var b = i(this.COORDINATE)
        , c = this.$range[0].getBoundingClientRect()[this.DIRECTION] + function j(a, b) {
          return a = i(a),
          void 0 !== window["page" + a + "Offset"] ? window["page" + a + "Offset"] : (document.documentElement || document.body.parentNode || document.body)["scroll" + i(b)]
      }(this.COORDINATE, this.DIRECTION)
        , d = 0;
      return void 0 !== a["page" + b] ? d = a["page" + b] : void 0 !== a.originalEvent["client" + b] ? d = a.originalEvent["client" + b] : a.originalEvent.touches && a.originalEvent.touches[0] && void 0 !== a.originalEvent.touches[0]["client" + b] ? d = a.originalEvent.touches[0]["client" + b] : a.currentPoint && void 0 !== a.currentPoint[this.COORDINATE] && (d = a.currentPoint[this.COORDINATE]),
      d - c
  }
  ,
  k.prototype.getPositionFromValue = function(a) {
      return (a && (a - this.min) / (this.max - this.min)) * this.maxHandlePos
  }
  ,
  k.prototype.getValueFromPosition = function(a) {
      var b, c;
      return b = a / (this.maxHandlePos || 1),
      c = this.step * Math.round(b * (this.max - this.min) / this.step) + this.min,
      Number(c.toFixed(this.toFixed))
  }
  ,
  k.prototype.setValue = function(a) {
      a !== this.value && this.$element.val(a).trigger("input", {
          origin: this.identifier
      })
  }
  ,
  k.prototype.destroy = function() {
      this.$document.off("." + this.identifier),
      this.$window.off("." + this.identifier),
      this.$element.off("." + this.identifier).removeAttr("style").removeData("plugin_" + l),
      this.$range && this.$range.length && this.$range[0].parentNode.removeChild(this.$range[0])
  }
  ,
  a.fn[l] = function(b) {
      var c = Array.prototype.slice.call(arguments, 1);
      return this.each((function() {
          var d = a(this)
            , e = d.data("plugin_" + l);
          e || d.data("plugin_" + l, e = new k(this,b)),
          "string" == typeof b && e[b].apply(e, c)
      }
      ))
  }
}
)),
function($) {
  $(document).ready((function() {
      const calculatorConstants = {
          "simple-interest": {
              totalInvestments: {
                  default: 1e4,
                  min: 1e4,
                  max: 1e7
              },
              expectedReturns: {
                  default: 10,
                  min: 1,
                  max: 50
              },
              tenure: {
                  default: 5,
                  min: 1,
                  max: 25
              }
          }
      };
      let totalInvestments = calculatorConstants["simple-interest"].totalInvestments.default
        , expectedReturns = calculatorConstants["simple-interest"].expectedReturns.default
        , tenure = calculatorConstants["simple-interest"].tenure.default;
      const totalInvestmentsHTML = document.getElementById("total-investment")
        , investedAmountHTML = document.getElementById("invested-amount")
        , estAmountHTML = document.getElementById("est-amount")
        , ctx = document.getElementById("mfChart").getContext("2d");
      let mfChart, mfinvested, mfest;
      function drawChart() {
          mfChart = new Chart(ctx,{
              type: "doughnut",
              data: {
                  labels: ["Total Investment Amount", "Total Interest"],
                  datasets: [{
                      label: "Simple Interest Calculator",
                      data: [mfinvested, mfest],
                      cutout: "70%",
                      backgroundColor: ["#43165C", "#E79D0D"],
                      hoverOffset: 4
                  }]
              },
              options: {
                  responsive: !1,
                  locale: "en-IN",
                  maintainAspectRatio: !1,
                  layout: {
                      padding: 30
                  },
                  plugins: {
                      legend: {
                          display: !1
                      }
                  }
              }
          })
      }
      function forceValueRanges(input, type, forceMin=!1) {
          const value = Number(input.val())
            , allowedMax = calculatorConstants["simple-interest"][type].max
            , allowedMin = calculatorConstants["simple-interest"][type].min;
          value > allowedMax && input.val(allowedMax),
          forceMin && function forceMinValues() {
              value < allowedMin && value && input.val(allowedMin)
          }()
      }
      function calculateSimpleIntReturn() {
          const totalInvestmentValue = Number(totalInvestments);
          let Principalamount = totalInvestmentValue
            , Totalinterest = totalInvestmentValue * Number(tenure) * (Number(expectedReturns) / 100)
            , TotalAmount = Totalinterest + Principalamount;
          return isNaN(Principalamount) && (Principalamount = 0),
          isNaN(Totalinterest) && (Totalinterest = 0),
          isNaN(TotalAmount) && (TotalAmount = 0),
          [Principalamount, TotalAmount, Totalinterest]
      }
      function updateTextValues() {
          return function updateSimpleIntTextValues() {
              const totalReturnValue = calculateSimpleIntReturn()
                , userTotalInvestment = Number(totalReturnValue[0])
                , returnValue = Number(totalReturnValue[2]);
              totalInvestmentsHTML.innerHTML = "₹ " + Number(totalReturnValue[0]).toLocaleString("en-IN"),
              investedAmountHTML.innerHTML = "₹ " + Number(totalReturnValue[1]).toLocaleString("en-IN"),
              estAmountHTML.innerHTML = "₹ " + Number(totalReturnValue[2]).toLocaleString("en-IN"),
              mfinvested = userTotalInvestment,
              mfest = returnValue
          }()
      }
      $('input[type="range"]').rangeslider({
          polyfill: !1,
          rangeClass: "rangeslider",
          disabledClass: "rangeslider--disabled",
          horizontalClass: "rangeslider--horizontal",
          verticalClass: "rangeslider--vertical",
          fillClass: "rangeslider__fill",
          handleClass: "rangeslider__handle",
          onInit: function() {},
          onSlide: function(position, value) {},
          onSlideEnd: function(position, value) {}
      }),
      $("input#total-investment-input").on("input", (function(event) {
          forceValueRanges($("input#total-investment-input"), "totalInvestments"),
          totalInvestments = Number(event.target.value),
          $("input#total-investment-input-slider").val(totalInvestments).change()
      }
      )),
      $("input#expected-returns-input").on("input", (function(event) {
          forceValueRanges($("input#expected-returns-input"), "expectedReturns", !0),
          expectedReturns = Number(event.target.value),
          $("input#expected-returns-input-slider").val(expectedReturns).change()
      }
      )),
      $("input#tenure-input").on("input", (function(event) {
          forceValueRanges($("input#tenure-input"), "tenure", !0),
          tenure = Number(event.target.value),
          $("input#tenure-input-slider").val(tenure).change()
      }
      )),
      $("input#total-investment-input-slider").on("input", (function(event) {
          totalInvestments = Number(event.target.value),
          totalInvestments > 0 && $("input#total-investment-input").val(totalInvestments)
      }
      )),
      $("input#expected-returns-input-slider").on("input", (function(event) {
          expectedReturns = Number(event.target.value),
          $("input#expected-returns-input").val(expectedReturns)
      }
      )),
      $("input#tenure-input-slider").on("input", (function(event) {
          tenure = Number(event.target.value),
          $("input#tenure-input").val(tenure)
      }
      )),
      $("input[type=number]").on("keydown", (function(e) {
          ["-", "+", "e"].includes(e.key) && e.preventDefault()
      }
      )),
      $(document).on("input", (function() {
          mfChart.destroy(),
          updateTextValues(),
          drawChart()
      }
      )),
      function init() {
          updateTextValues(),
          drawChart()
      }()
  }
  ))
}(jQuery),
function($) {
  $(document).ready((function() {
      $(".calculator_help_section").on("click", ".panel-trigger", (function() {
          var val = $(this).attr("val");
          $(".calculator_help_section").find(".panel-collapse:not('" + val + "')").slideUp("fast");
          var inactiveTab = $(".calculator_help_section").find(".panel-trigger:not([val='" + val + "'])");
          $(this).toggleClass("collapsed"),
          $(val).slideToggle("fast"),
          inactiveTab.hasClass("collapsed") && inactiveTab.removeClass("collapsed")
      }
      )),
      $(".btn-all").click((function() {
          $(".smooth-wrap").addClass("smooth-wrap2"),
          $(".btn-all").hide(),
          $(".btn-less").show()
      }
      )),
      $(".btn-less").click((function() {
          $(".smooth-wrap").removeClass("smooth-wrap2"),
          $(".btn-all").show(),
          $(".btn-less").hide()
      }
      ))
  }
  ))
}(jQuery);
//# sourceMappingURL=simple-interest.js.map
